import { _GameNameHorizontalBase } from './gameNameHorizontalBase'

export class _GameNameHorizontalDefault extends _GameNameHorizontalBase {
  cssType: 'default' | 'small' | 'larger' = 'default'
  protected initPC(): this {
    this['--game-name-horizontal-padding'] = '0.04rem 0.1rem 0.1rem'
    this['--left-logo-width'] = '0.4rem'
    this['--left-logo-height'] = '0.4rem'
    this['--right-name-margin-left'] = '0.05rem'
    this['--right-name-font-size'] = '0.24rem'
    return this
  }
  protected initH5(): this {
    this['--game-name-horizontal-padding'] = '0.06rem 0.15rem  0.1rem'
    this['--left-logo-width'] = '0.46rem'
    this['--left-logo-height'] = '0.46rem'
    this['--right-name-margin-left'] = '0.1rem'
    this['--right-name-font-size'] = '0.28rem'
    return this
  }
}
